// src/mocks/handlers/dashboard/index.ts

import { requestFundsAvailableFundsHandler } from './requestFunds_availableFunds';
import { topOutstandingInvoicesHandler } from './topOutstandingInvoicesHandler';
import { requestFundsRequestFundsHandler } from './requestFunds_requestFunds';
import { latestAdvancesHandler } from './latestAdvancesHandler';
import { latestCollectionsHandler } from './latestCollections';
import { sourceExposureHandler } from './sourceExposure';
import { currencyExposureHandler } from './currencyExposure';
import { balanceFundingHandler } from './balanceFunding';
import { topCampaignsHandler } from './topCampaigns';

export const dashboardHandlers = [
  requestFundsAvailableFundsHandler,
  requestFundsRequestFundsHandler,
  topOutstandingInvoicesHandler,
  latestAdvancesHandler,
  latestCollectionsHandler,
  sourceExposureHandler,
  currencyExposureHandler,
  balanceFundingHandler,
  topCampaignsHandler,
];
